import React, {useContext, useEffect} from "react";

import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {loadScriptPromise} from "../../../utilities/loadScript";
import ACHContractDocument from "./ACHContractDocument";
import {bundleReactPdf, contractUrl} from "./achConstants";


const ACHCredentialsPopupContent = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const loadACHContract = async () => {
    uiPopupDispatch({isLoading: true, saveButtonDisabled: true}); // no sign yet
    try {
      await loadScriptPromise(bundleReactPdf, "bundleReactPdf");
      const responseFetch = await fetch(contractUrl);
      const blob = await responseFetch.blob();
      const blobUrl = URL.createObjectURL(blob);
      uiPopupDispatch({isLoading: false, blobUrl, blob});
    } catch (e) {
      uiPopupDispatch({isLoading: false, blobUrl: ""});
    }
  }

  console.log("uiPopupContext", uiPopupContext);

  useEffect(() => {
    loadACHContract();
  }, []);

  return (
    <div className="pl-1 pt-1 pr-075 flex-item mr-075 flex flex--column">
      {uiPopupContext.isLoading ? (
        <div className="flex-item flex flex--center relative">
          <div className="ui-loader ui-loader--medium"/>
        </div>
      ) : <ACHContractDocument/>}
    </div>
  )
}

export default ACHCredentialsPopupContent
